export enum CheckoutStorageKey {
    BillingAddress = 'BillingAddress',
    GiftCard = 'GiftCard',
    LoyaltyCardNumber = 'LoyaltyCardNumber',
    LoyaltyAmount = 'LoyaltyAmount',
    TermsAndCondition = 'TermsAndCondition',
    CheckoutGenericData = 'Checkout-Generic-Data',
    PaymentTenderType = 'PaymentTenderType'
}